/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { ToggleDisabledStatus } from '../../components/SnippetsContainer/Snippets/types';
import { isCloudMethod } from '../isCloudMethod/isCloudMethod';
import { isSelfHostedMethod } from '../isSelfHostedMethod/isSelfHostedMethod';
import type { GetInstallationMethodToggleStatusArgs } from './types';

export function getInstallationMethodToggleStatus( {
	key,
	selectedTechnology,
	isLoggedIn,
	isTrialActive,
	hasCloudAccess,
	hasSelfHostedAccess,
	hasOldGPLAccess
}: GetInstallationMethodToggleStatusArgs ): ToggleDisabledStatus {
	if ( !selectedTechnology ) {
		return {
			disabled: true,
			tooltip: 'Select the technology first.'
		};
	}

	if ( isLoggedIn && !isTrialActive && isSelfHostedMethod( key ) && ( !hasSelfHostedAccess && !hasOldGPLAccess ) ) {
		return {
			disabled: true,
			tooltip: 'Your subscription doesn\'t support this method. Contact us for details.'
		};
	}

	if ( isLoggedIn && !isTrialActive && isCloudMethod( key ) && !hasCloudAccess ) {
		return {
			disabled: true,
			tooltip: 'Your subscription doesn\'t support this method. Contact us for details.'
		};
	}

	if ( selectedTechnology !== 'js' && key === 'zip' ) {
		return {
			disabled: true,
			tooltip: 'Stay tuned, coming soon!'
		};
	}

	return { disabled: false, tooltip: null };
}
